// Modules

import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

export const REDIRECT_PAGE_NOTIFIER_ID = 'redirectPage';
export const USER_PROFILE_SET_NOTIFIER_ID = 'userProfileSet';
export const INVALID_GROUP_ACCESS = 'Invalid Group Access';
export const GROUP_METADATA = 'https://vixxo.com/groups';

@Injectable()
export class B2CAuthService {
  refreshSubscription: any;

  constructor(private msalService: MsalService) {}

  public handleRedirectCallback() {
    this.msalService.handleRedirectCallback(authResponse => {
      console.log(authResponse, 'AuthResponse');
    });

    this.msalService.getAccount();
  }
}
